import {
  Box,
  Container,
  Grid2 as Grid,
  CircularProgress,
  Drawer,
} from "@mui/material";
import CustomersGrid from "../../admin/CustomersGrid";
import { useEffect, useRef, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";
import { getCustomers } from "../../../store/actions/dataActions";
import EditCustomer from "../../admin/EditCustomer";

const Customers = () => {
  const currentSession = useSelector((state) => state.sessions.currentSession);
  const currentUser = useSelector((state) => state[currentSession].user);

  const navigate = useNavigate();
  const dispatch = useDispatch();

  const [customerSelectedRow, setCustomerSelectedRow] = useState(null);
  const [loading, setLoading] = useState(true);
  const [dataLoading, setDataLoading] = useState(false);
  const [openDrawer, setOpenDrawer] = useState(false);

  const fetchDataRef = useRef();

  useEffect(() => {
    if (currentUser?.user) {
      if (currentUser?.user?.role !== "admin" || !currentUser?.user?.admin) {
        navigate("/login");
      }
    }
  }, [currentUser?.user, navigate]);

  useEffect(() => {
    const fetchData = async () => {
      setDataLoading(true);

      let page = null;
      let rowsPerPage = null;
      let selectedCustomerId = null;

      try {
        const stored = sessionStorage.getItem("adminRemoteCustomersState");
        if (stored) {
          const parsed = JSON.parse(stored);
          page =
            typeof parsed.page === "number" && parsed.page >= 0
              ? parsed.page
              : null;
          rowsPerPage =
            typeof parsed.pageSize === "number" && parsed.pageSize > 0
              ? parsed.pageSize
              : null;
          selectedCustomerId = parsed.selectedCustomerId || null;
        }
      } catch (e) {
        // ignore parse errors
      }

      const resp = await dispatch(
        getCustomers({
          page: page,
          rowsPerPage: rowsPerPage,
        })
      );

      if (resp) {
        // If we had a previously selected customer, restore it
        if (selectedCustomerId) {
          const restoredRow = resp.find((row) => row.id === selectedCustomerId);
          if (restoredRow) {
            setCustomerSelectedRow(restoredRow);
          }
        }

        // Clear the stored state after using it once
        try {
          sessionStorage.removeItem("adminRemoteCustomersState");
        } catch (e) {
          // ignore
        }

        setDataLoading(false);
        setLoading(false);
      }
    };

    if (!fetchDataRef?.current) {
      fetchDataRef.current = true;
      fetchData();
    }
  }, [dispatch, setCustomerSelectedRow]);

  return (
    <>
      {loading ? (
        <>
          <Box
            sx={{
              display: "flex",
              width: "100%",
              height: "100vh",
              justifyContent: "center",
              alignItems: "center",
              flexDirection: "column",
            }}
          >
            <CircularProgress color="warning" size="10rem" />
          </Box>
        </>
      ) : (
        <>
          <Box
            component="main"
            sx={{
              flexGrow: 1,
              py: 1,
              backgroundColor: "#EEF2F6",
            }}
          >
            <Container maxWidth="xl">
              <Grid container spacing={3}>
                <Grid size={{ xs: 12, md: 12, lg: 12 }}>
                  <CustomersGrid
                    customerSelectedRow={customerSelectedRow}
                    setCustomerSelectedRow={setCustomerSelectedRow}
                    dataLoading={dataLoading}
                    setDataLoading={setDataLoading}
                  />
                </Grid>
              </Grid>
            </Container>
          </Box>

          {/* *********************** BOTTOM LINE ******************************************** */}
          {/* ******************************************************************************** */}
          <Drawer
            slotProps={{
              paper: {
                sx: {
                  width: "50vw",
                },
              },
            }}
            anchor="right"
            open={openDrawer}
            onClose={() => setOpenDrawer(false)}
          >
            <EditCustomer
              row={customerSelectedRow}
              setCustomerSelectedRow={setCustomerSelectedRow}
              setOpenDrawer={setOpenDrawer}
            />
          </Drawer>
        </>
      )}
    </>
  );
};

export default Customers;
